import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface TagPatchPoliciesTabProps { tagId: string; }

export const TagPatchPoliciesTab = ({ tagId }: TagPatchPoliciesTabProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  // No backend API for patch policy tags — show empty state
  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input placeholder="Search patch policies..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="pl-10" />
      </div>
      <div className="text-center py-12 text-muted-foreground">
        Patch policy tag assignments require a backend Patch Management API. Coming soon.
      </div>
    </div>
  );
};
